import React from 'react'
import './Names.css'
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { CardActionArea } from '@mui/material';
import tushar from './tushar.png'
import aman from './aman.png'
import dharambir from './dharambir.png'
import sunayan from './sunayan.png'
import sabhishek from './sabhishek.png'
import yusuf from './yusuf.png'
import pranav from './pranav.png'
import rajiv from './rajiv.png'
import amit from './amit.png'
import sudipto from './sudipto.png'
import asad from './asad.png'
import keshav from './keshav.png'
import risabh from './risabh.png'
import swapnil from './swapnil.png'
import avinash from './avinash.png'
import rahul from './rahul.png'
import abhishek from './abhishek.png'
import aman1 from './aman1.png'
import guddu from './guddu.png'
import akash from './akash.png'
import rupesh from './rupesh.png'
import humza from './humza.png'
import minaz from './minaz.png'
import utk from './utk.png'
import arti from './arti.png'
import rawat from './rawat.png'
import kshi from './kshi.png'
import rajni from './rajni.png'
import sanji from './sanji.png'
import mannu from './mannu.png'
import varu from './varu.png'
import shalin from './shalin.png'
import LinkedInIcon from '@mui/icons-material/LinkedIn';
function Names() {
  return (
    <>
    <div className='names'>
    <div className='central'>
        <h2>Central Coordinators</h2>
    </div>
    <div className='centralPhoto'>
    <Card sx={{ maxWidth: 345 }} style={{margin:'10px',borderRadius:'2rem'}}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="250"
          image={dharambir}
          alt="green iguana"
        />
        <CardContent>
          <Typography style={{textAlign:'center'}} gutterBottom variant="h6" component="div">
            Dharambir Bharadwaj
          </Typography>
          <Typography style={{textAlign:'center'}} variant="body1" color="text.secondary">
           ECE (Final Year)
          </Typography>
          <Typography style={{textAlign:'center'}} variant="h6" color="text.secondary">
         
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
    <Card sx={{ maxWidth: 345 }} style={{margin:'10px',borderRadius:'2rem',fontFamily: 'Baloo Bhai 2', }}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="250"
          image={kshi}
          alt="green iguana"
        />
        <CardContent>
          <Typography style={{textAlign:'center'}} gutterBottom variant="h6" component="div">
            Kshitij Naman
          </Typography>
          <Typography style={{textAlign:'center'}} variant="body1" color="text.secondary">
           ME (Final Year)
          </Typography>
          <Typography style={{textAlign:'center'}} variant="h6" color="text.secondary">
         
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
    </div>
    <div className='webd1'>
        <h2>Website Designers</h2>
    </div>
    <div className='webd'>
    <Card sx={{ maxWidth: 345 }} style={{margin:'10px',borderRadius:'2rem'}}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="250"
          
          image={tushar}
          alt="green iguana"
        />
        <CardContent>
          <Typography style={{textAlign:'center'}} gutterBottom variant="h6" component="div">
            Tushar Deo
          </Typography>
          <Typography style={{textAlign:'center'}} variant="body1" color="text.secondary">
           ECE (3rd Year)
          </Typography>
          <Typography style={{textAlign:'center'}} variant="h6" color="text.secondary">
           [FrontEnd and BackEnd]
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
    <Card sx={{ maxWidth: 345 }} style={{margin:'10px',borderRadius:'2rem'}}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="250"
          image={aman1}
          alt="green iguana"
        />
        <CardContent>
          <Typography style={{textAlign:'center'}} gutterBottom variant="h6" component="div">
            Aman Kumar Singh
          </Typography>
          <Typography style={{textAlign:'center'}} variant="body1" color="text.secondary">
           ECE (3rd Year)
          </Typography>
          <Typography style={{textAlign:'center'}} variant="h6" color="text.secondary">
           [BackEnd and Design]
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
    </div>
    <div className='webd'>
    <Card sx={{ maxWidth: 345 }} style={{margin:'10px',borderRadius:'2rem'}}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="250"
          image={akash}
          alt="green iguana"
        />
        <CardContent>
          <Typography style={{textAlign:'center'}} gutterBottom variant="h6" component="div">
            Akash Kumar Singh
          </Typography>
          <Typography style={{textAlign:'center'}} variant="body1" color="text.secondary">
           EE (3rd Year)
          </Typography>
          <Typography style={{textAlign:'center'}} variant="h6" color="text.secondary">
         
          </Typography>
         
          <Typography style={{textAlign:'center'}} variant="h6" color="text.secondary">
           [FrontEnd]
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
    <Card sx={{ maxWidth: 345 }} style={{margin:'10px',borderRadius:'2rem'}}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="250"
          image={guddu}
          alt="green iguana"
        />
        <CardContent>
          <Typography style={{textAlign:'center'}} gutterBottom variant="h6" component="div">
            Shubham Kumar Mahato
          </Typography>
          <Typography style={{textAlign:'center'}} variant="body1" color="text.secondary">
           ECE (3rd Year)
          </Typography>
          <Typography style={{textAlign:'center'}} variant="h6" color="text.secondary">
           [FrontEnd and Design]
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
    </div>
    <div className='central'>
        <h2>Coordinators</h2>
    </div>
    <div className='centralPhoto'>
    <Card sx={{ maxWidth: 345 }} style={{margin:'10px',borderRadius:'2rem'}}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="250"
          image={yusuf}
          alt="green iguana"
        />
        <CardContent>
          <Typography style={{textAlign:'center'}} gutterBottom variant="h6" component="div">
            Yusuf Akhtar
          </Typography>
          <Typography style={{textAlign:'center'}} variant="body1" color="text.secondary">
           ECE (Final Year)
          </Typography>
          <Typography style={{textAlign:'center'}} variant="h6" color="text.secondary">
         
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
    <Card sx={{ maxWidth: 345 }} style={{margin:'10px',borderRadius:'2rem'}}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="250"
          image={sunayan}
          alt="green iguana"
        />
        <CardContent>
          <Typography style={{textAlign:'center'}} gutterBottom variant="h6" component="div">
            Sunayan Ghosh
          </Typography>
          <Typography style={{textAlign:'center'}} variant="body1" color="text.secondary">
           ECE (Final Year)
          </Typography>
          <Typography style={{textAlign:'center'}} variant="h6" color="text.secondary">
         
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
    </div>
      <div className="centralPhoto">
      <Card sx={{ maxWidth: 345 }} style={{margin:'10px',borderRadius:'2rem'}}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="250"
          
          image={sabhishek}
          alt="green iguana"
        />
        <CardContent>
          <Typography style={{textAlign:'center'}} gutterBottom variant="h6" component="div">
            Saurabh Abhishek
          </Typography>
          <Typography style={{textAlign:'center'}} variant="body1" color="text.secondary">
           ECE (Final Year)
          </Typography>
          <Typography style={{textAlign:'center'}} variant="h6" color="text.secondary">
         
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
    <Card sx={{ maxWidth: 345 }} style={{margin:'10px',borderRadius:'2rem'}}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="250"
          image={arti}
          alt="green iguana"
        />
        <CardContent>
          <Typography style={{textAlign:'center'}} gutterBottom variant="h6" component="div">
            Arti Kumari
          </Typography>
          <Typography style={{textAlign:'center'}} variant="body1" color="text.secondary">
           AEIE (Final Year)
          </Typography>
          <Typography style={{textAlign:'center'}} variant="h6" color="text.secondary">
         
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
      </div>
      <div className='centralPhoto'>
      <Card sx={{ maxWidth: 345 }} style={{margin:'10px',borderRadius:'2rem'}}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="250"
          image={utk}
          alt="green iguana"
        />
        <CardContent>
          <Typography style={{textAlign:'center'}} gutterBottom variant="h6" component="div">
            Utkarsh Srivastava
          </Typography>
          <Typography style={{textAlign:'center'}} variant="body1" color="text.secondary">
           AEIE (Final Year)
          </Typography>
          <Typography style={{textAlign:'center'}} variant="h6" color="text.secondary">
         
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
    <Card sx={{ maxWidth: 345 }} style={{margin:'10px',borderRadius:'2rem'}}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="250"
          image={rajni}
          alt="green iguana"
        />
        <CardContent>
          <Typography style={{textAlign:'center'}} gutterBottom variant="h6" component="div">
            Rajnish Bhardwaj
          </Typography>
          <Typography style={{textAlign:'center'}} variant="body1" color="text.secondary">
           CSE (Final Year)
          </Typography>
          <Typography style={{textAlign:'center'}} variant="h6" color="text.secondary">
         
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
      </div>
      <div className='centralPhoto'>
      <Card sx={{ maxWidth: 345 }} style={{margin:'10px',borderRadius:'2rem'}}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="250"
          image={sanji}
          alt="green iguana"
        />
        <CardContent>
          <Typography style={{textAlign:'center'}} gutterBottom variant="h6" component="div">
            Sanjeev Kumar
          </Typography>
          <Typography style={{textAlign:'center'}} variant="body1" color="text.secondary">
           CSE (Final Year)
          </Typography>
          <Typography style={{textAlign:'center'}} variant="h6" color="text.secondary">
         
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
    <Card sx={{ maxWidth: 345 }} style={{margin:'10px',borderRadius:'2rem'}}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="250"
          image={mannu}
          alt="green iguana"
        />
        <CardContent>
          <Typography style={{textAlign:'center'}} gutterBottom variant="h6" component="div">
            Mannu Raj
          </Typography>
          <Typography style={{textAlign:'center'}} variant="body1" color="text.secondary">
           CSE (Final Year)
          </Typography>
          <Typography style={{textAlign:'center'}} variant="h6" color="text.secondary">
         
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
      </div>
      <div className='centralPhoto'>
      <Card sx={{ maxWidth: 345 }} style={{margin:'10px',borderRadius:'2rem'}}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="250"
          image={varu}
          alt="green iguana"
        />
        <CardContent>
          <Typography style={{textAlign:'center'}} gutterBottom variant="h6" component="div">
            Varun Raj
          </Typography>
          <Typography style={{textAlign:'center'}} variant="body1" color="text.secondary">
           CSE (Final Year)
          </Typography>
          <Typography style={{textAlign:'center'}} variant="h6" color="text.secondary">
         
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
    <Card sx={{ maxWidth: 345 }} style={{margin:'10px',borderRadius:'2rem'}}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="250"
          image={pranav}
          alt="green iguana"
        />
        <CardContent>
          <Typography style={{textAlign:'center'}} gutterBottom variant="h6" component="div">
            Pranav
          </Typography>
          <Typography style={{textAlign:'center'}} variant="body1" color="text.secondary">
           IT (Final Year)
          </Typography>
          <Typography style={{textAlign:'center'}} variant="h6" color="text.secondary">
         
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
      </div>
      <div className='centralPhoto'>
      <Card sx={{ maxWidth: 345 }} style={{margin:'10px',borderRadius:'2rem'}}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="250"
          image={rajiv}
          alt="green iguana"
        />
        <CardContent>
          <Typography style={{textAlign:'center'}} gutterBottom variant="h6" component="div">
            Rajeev Ranjan
          </Typography>
          <Typography style={{textAlign:'center'}} variant="body1" color="text.secondary">
           IT (Final Year)
          </Typography>
          <Typography style={{textAlign:'center'}} variant="h6" color="text.secondary">
         
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
    <Card sx={{ maxWidth: 345 }} style={{margin:'10px',borderRadius:'2rem'}}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="250"
          image={amit}
          alt="green iguana"
        />
        <CardContent>
          <Typography style={{textAlign:'center'}} gutterBottom variant="h6" component="div">
            Amit Kumar
          </Typography>
          <Typography style={{textAlign:'center'}} variant="body1" color="text.secondary">
           IT (Final Year)
          </Typography>
          <Typography style={{textAlign:'center'}} variant="h6" color="text.secondary">
         
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
      </div>
      <div className='centralPhoto'>
      <Card sx={{ maxWidth: 345 }} style={{margin:'10px',borderRadius:'2rem'}}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="250"
          image={sudipto}
          alt="green iguana"
        />
        <CardContent>
          <Typography style={{textAlign:'center'}} gutterBottom variant="h6" component="div">
            Sudipto Ghosh
          </Typography>
          <Typography style={{textAlign:'center'}} variant="body1" color="text.secondary">
           IT (Final Year)
          </Typography>
          <Typography style={{textAlign:'center'}} variant="h6" color="text.secondary">
         
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
    <Card sx={{ maxWidth: 345 }} style={{margin:'10px',borderRadius:'2rem'}}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="250"
          image={rupesh}
          alt="green iguana"
        />
        <CardContent>
          <Typography style={{textAlign:'center'}} gutterBottom variant="h6" component="div">
            Rupesh Ranjan
          </Typography>
          <Typography style={{textAlign:'center'}} variant="body1" color="text.secondary">
           EE (Final Year)
          </Typography>
          <Typography style={{textAlign:'center'}} variant="h6" color="text.secondary">
         
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
      </div>
      <div className='centralPhoto'>
      <Card sx={{ maxWidth: 345 }} style={{margin:'10px',borderRadius:'2rem'}}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="250"
          image={rawat}
          alt="green iguana"
        />
        <CardContent>
          <Typography style={{textAlign:'center'}} gutterBottom variant="h6" component="div">
            Bishal Kumar Rawat
          </Typography>
          <Typography style={{textAlign:'center'}} variant="body1" color="text.secondary">
           EE (Final Year)
          </Typography>
          <Typography style={{textAlign:'center'}} variant="h6" color="text.secondary">
         
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
    <Card sx={{ maxWidth: 345 }} style={{margin:'10px',borderRadius:'2rem'}}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="250"
          image={minaz}
          alt="green iguana"
        />
        <CardContent>
          <Typography style={{textAlign:'center'}} gutterBottom variant="h6" component="div">
            Md. Minhaz Imroz
          </Typography>
          <Typography style={{textAlign:'center'}} variant="body1" color="text.secondary">
           EE (Final Year)
          </Typography>
          <Typography style={{textAlign:'center'}} variant="h6" color="text.secondary">
         
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
      </div>
      <div className='centralPhoto'>
      <Card sx={{ maxWidth: 345 }} style={{margin:'10px',borderRadius:'2rem'}}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="250"
          image={shalin}
          alt="Shalini Kumari"
        />
        <CardContent>
          <Typography style={{textAlign:'center'}} gutterBottom variant="h6" component="div">
            Shalini Kumari
          </Typography>
          <Typography style={{textAlign:'center'}} variant="body1" color="text.secondary">
           EE (Final Year)
          </Typography>
          <Typography style={{textAlign:'center'}} variant="h6" color="text.secondary">
         
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
    <Card sx={{ maxWidth: 345 }} style={{margin:'10px',borderRadius:'2rem'}}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="250"
          image={asad}
          alt="green iguana"
        />
        <CardContent>
          <Typography style={{textAlign:'center'}} gutterBottom variant="h6" component="div">
            Md. Asad
          </Typography>
          <Typography style={{textAlign:'center'}} variant="body1" color="text.secondary">
           ME (Final Year)
          </Typography>
          <Typography style={{textAlign:'center'}} variant="h6" color="text.secondary">
         
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
      </div>
      <div className="centralPhoto">
      <Card sx={{ maxWidth: 345 }} style={{margin:'10px',borderRadius:'2rem'}}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="250"
          image={risabh}
          alt="green iguana"
        />
        <CardContent>
          <Typography style={{textAlign:'center'}} gutterBottom variant="h6" component="div">
            Rishabh Tiwari
          </Typography>
          <Typography style={{textAlign:'center'}} variant="body1" color="text.secondary">
           ME (Final Year)
          </Typography>
          <Typography style={{textAlign:'center'}} variant="h6" color="text.secondary">
         
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
    <Card sx={{ maxWidth: 345 }} style={{margin:'10px',borderRadius:'2rem'}}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="250"
          image={avinash}
          alt="green iguana"
        />
        <CardContent>
          <Typography style={{textAlign:'center'}} gutterBottom variant="h6" component="div">
            Avinash Ranjan
          </Typography>
          <Typography style={{textAlign:'center'}} variant="body1" color="text.secondary">
           ME (Final Year)
          </Typography>
          <Typography style={{textAlign:'center'}} variant="h6" color="text.secondary">
         
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
      </div>
      <div className="centralPhoto">
      <Card sx={{ maxWidth: 345 }} style={{margin:'10px',borderRadius:'2rem'}}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="250"
          image={keshav}
          alt="green iguana"
        />
        <CardContent>
          <Typography style={{textAlign:'center'}} gutterBottom variant="h6" component="div">
            Keshav Kumar Mandal
          </Typography>
          <Typography style={{textAlign:'center'}} variant="body1" color="text.secondary">
           CE (Final Year)
          </Typography>
          <Typography style={{textAlign:'center'}} variant="h6" color="text.secondary">
         
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
    <Card sx={{ maxWidth: 345 }} style={{margin:'10px',borderRadius:'2rem'}}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="250"
          image={abhishek}
          alt="green iguana"
        />
        <CardContent>
          <Typography style={{textAlign:'center'}} gutterBottom variant="h6" component="div">
            Avishek Biswakarma
          </Typography>
          <Typography style={{textAlign:'center'}} variant="body1" color="text.secondary">
           CE (Final Year)
          </Typography>
          <Typography style={{textAlign:'center'}} variant="h6" color="text.secondary">
         
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
      </div>
      <div className='centralPhoto'>
      <Card sx={{ maxWidth: 345 }} style={{margin:'10px',borderRadius:'2rem'}}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="250"
          image={rahul}
          alt="green iguana"
        />
        <CardContent>
          <Typography style={{textAlign:'center'}} gutterBottom variant="h6" component="div">
            Rahul Das Baneerjee
          </Typography>
          <Typography style={{textAlign:'center'}} variant="body1" color="text.secondary">
           CE (Final Year)
          </Typography>
          <Typography style={{textAlign:'center'}} variant="h6" color="text.secondary">
         
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
    <Card sx={{ maxWidth: 345 }} style={{margin:'10px',borderRadius:'2rem'}}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="250"
          image={swapnil}
          alt="green iguana"
        />
        <CardContent>
          <Typography style={{textAlign:'center'}} gutterBottom variant="h6" component="div">
            Swapnil Singh
          </Typography>
          <Typography style={{textAlign:'center'}} variant="body1" color="text.secondary">
           CE (Final Year)
          </Typography>
          <Typography style={{textAlign:'center'}} variant="h6" color="text.secondary">
         
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
      </div>
      <div className='centralPhoto'>
      <Card sx={{ maxWidth: 345, }} style={{margin:'10px',borderRadius:'2rem'}}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="250"
          image={humza}
          alt="green iguana"
        />
        <CardContent>
          <Typography style={{textAlign:'center'}} gutterBottom variant="h6" component="div">
            Humza Yusuf 
          </Typography>
          <Typography style={{textAlign:'center'}} variant="body1" color="text.secondary">
           MBA
          </Typography>
          <Typography style={{textAlign:'center'}} variant="h6" color="text.secondary">
         
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
      </div>
      </div>
    </>
  )
}

export default Names